import {useState, useEffect, useContext} from "react";
import { Colors } from "./Colors";
import { Count } from "./Count";
import { useForm } from "../../Hooks";
import { Sizes } from "./Sizes";
import { CiShoppingCart } from 'react-icons/ci'
import { StoreContextMain } from "../../Context/StoreContextMain";


export const Characteristics = ({category}) => {

    const { setSelectedCharacteristics } = useContext(StoreContextMain)

    const [colors, setColors] = useState(null);
    const [sizes, setSizes] = useState(null);
    const [cantidad, setCantidad] = useState(0);

    const [attributes, setAttributes] = useState(null);

    const {formState, onInputChange} = useForm({});

    const [activeColor, setActiveColor] = useState(null)
    const [activeSize, setActiveSize] = useState(null)
    const [count, setCount] = useState(0)
    const [getCategorys, setCategorys] = useState([])

    useEffect(()=> {
        try {
            let colores = new Set()
            let tallas = new Set()
            let categories = category[0]?.category.map( (item) => item.category )
            let lenCategories = categories.length;
            
            console.log(lenCategories, category)

            setCategorys(categories)
    
            setAttributes(category)
    
            category?.forEach(item => {
    
                item?.category.forEach( cat => {
                    if (cat.category === "Colores") {
                        colores.add( cat.name )
                    }
                    if (cat.category === "Tallas") {
                        tallas.add( cat.name )
                    }
                })
                // colores.add(...item?.category.filter( cat => {
                //     if (cat.category === "Colores") {
                //         delete cat.uuid
                //         delete cat.created_at
    
                //         return cat
                //     }
                //     return false
                // } ))
                // tallas.add(...item?.category.filter( cat => {
                //     if (cat.category === "Tallas") {
                //         delete cat.uuid
                //         delete cat.created_at
    
                //         return cat.name
                //     }
                //     return false
                // } ))
            })
    
            setColors(Array.from(colores))
            setSizes(Array.from(tallas))
    
            return () => {
                setColors(null)
                setSizes(null)
            }
        } catch (e) {
            console.log(e)
        }

    }, [category])

    useEffect ( ()=> {
        if (getCategorys.length === 2) {
            if(activeColor && activeSize) {
                getAvailableProducts()
            }
        } else if (getCategorys.length === 1) {

        }
        setSelectedCharacteristics({
            color:activeColor,
            size: activeSize,
            amount: count,
            amount_max: cantidad
        })

    }, [activeColor, activeSize, count, setSelectedCharacteristics, getCategorys] )

    const updateColorsBySize = (size) => {
        try {
            let colores = new Set()

            if (size) {
                const filterColorBySize = category.filter( (item) => {
                    return item.category.find( (found) => found.name === size )
                } ).map( (color) => color.category.find((cat) => cat.category === "Colores")); 

                filterColorBySize.flat().forEach(item => {
                    if (item.category === "Colores") {
                        colores.add( item.name )
                    }
                })

                // setColors(filterColorBySize.flat());

            } else {
                // Reset colors to all colors if no size is selected
                category.forEach(item => {
                    item?.category.forEach(cat => {
                        if (cat.category === 'Colores')  colores.add(cat.name)
                    })
                })
                // setColors(colores);
              }

              setColors(Array.from(colores));
        } catch (e) {

        }
    }

    const updateSizesByColor = (color) => {
        try {
            let tallas = new Set()

            if (color) {
                const filtredSizes = category.filter( (item) => {
                    return item.category.find( (found) => found.name === color )
                } ).map( (size) => size.category.find(cat => cat.category === 'Tallas') );
                
                filtredSizes.flat().forEach(item => {
                    if (item.category === "Tallas") {
                        tallas.add( item.name )
                    }
                })
                // setSizes(Array.from(tallas))
            } else {
                category.forEach(item => {
                    item?.category.forEach(cat => {
                        if (cat.category === 'Tallas')  tallas.add(cat.name)
                    })
                })
                // setSizes(Array.from(tallas))
            }

            setSizes(Array.from(tallas))

        } catch (e) {

        }
    }

    const getAvailableProducts = () => {

        // Filtrar el array attributes según la talla y color seleccionados
        const availableProduct = attributes?.find((item) => {
            const hasSelectedColor = item.category.some(cat => cat.category === "Colores" && cat.name === activeColor);
            const hasSelectedSize = item.category.some(cat => cat.category === "Tallas" && cat.name === activeSize);

            return hasSelectedColor && hasSelectedSize;
        });
        setCantidad(availableProduct?.stock)
        
    }

    const handleColorChange = (color) => {
        if (activeColor === color) {
            setActiveColor(null)
            updateSizesByColor(null)
        } else {
            setActiveColor(color)
            updateSizesByColor(color)
        }
    }

    // Handle size selection
    const handleSizeChange = (size) => {
        if (activeSize === size) {
            setActiveSize(null);
            updateColorsBySize(null); 
        } else {
            setActiveSize(size);
            updateColorsBySize(size); 
        }
    };

    return (
        <div className="d-flex flex-column">

            <div className="mb-3">
                <h6 > Color </h6>
                <div className="d-flex flex-wrap">
                    {
                        colors?.map((color, index) => {
                            return (
                                <Colors
                                    key={index}
                                    colors={color}
                                    active={activeColor}
                                    handleColors={()=>handleColorChange(color)}
                                    // setActiveColor={setActiveColor}
                                />
                            );
                        })
                    }
                </div>
            </div>

            <div className="mb-3">
                <h6> Talla </h6>
                <div className="d-flex flex-wrap">
                    {
                        sizes?.map((size, index) => {
                            return (
                                <Sizes
                                    key={index}
                                    name={ size }
                                    active={activeSize}
                                    handleSizes={()=>handleSizeChange(size)}
                                />
                            );
                        })
                    } 
                </div>
            </div>
            
            <div className="mb-3 w-50">
                <h5> Cantidad </h5>
                <Count 
                    cantidad_max={cantidad} 
                    count={count} 
                    setCount={setCount}
                />
            </div>
        </div>
    );
};
